import { PackageProcessServiceBase, WsPackageProcess } from "./wsdl/WsPackageProcess/v1.04/WsPackageProcess.ts";

export {
    type WsPackageProcess
};

export class PackageProcessService extends PackageProcessServiceBase {
}
